{
  "name": "steto",
  "version": "1.2.85",
  "private": true,
  "type": "module",
  "scripts": {
    "dev": "vite",
    "build": "vite build",
    "preview": "vite preview",
    "test": "vitest",
    "test:watch": "vitest --watch --browser firefox",
    "test:ci": "vitest --coverage.enabled=false --project=unit",
    "fmt": "oxfmt",
    "lint": "oxlint",
    "typecheck": "tsgo",
    "check": "pnpm run lint --quiet && pnpm run fmt --check  && pnpm run typecheck",
    "analyze": "vite-bundle-visualizer --open --sourcemap",
    "knip": "knip",
    "storybook": "storybook dev",
    "build-storybook": "storybook build",
    "soups": "pnpm exec ./scripts/soups.sh >> soups.txt"
  },
  "dependencies": {
    "@emotion/css": "11.13.5",
    "@emotion/react": "11.14.0",
    "@emotion/styled": "11.14.1",
    "@floating-ui/react": "0.27.19",
    "@hookform/resolvers": "5.2.2",
    "@mui/icons-material": "9.2.0",
    "@mui/material": "9.2.0",
    "@mui/x-date-pickers": "9.9.0",
    "@sentry/react": "10.51.0",
    "@steto-care/steto-query": "1.3.0",
    "@tanstack/devtools-vite": "0.7.0",
    "@tanstack/react-devtools": "0.10.5",
    "@tanstack/react-pacer": "0.22.1",
    "@tanstack/react-query": "5.100.9",
    "@tanstack/react-query-devtools": "5.100.9",
    "@tanstack/react-router": "1.169.2",
    "@tanstack/react-router-devtools": "1.166.13",
    "@tanstack/react-table": "8.21.3",
    "@tiptap/core": "3.31.3",
    "@tiptap/extension-color": "3.31.3",
    "@tiptap/extension-heading": "3.31.3",
    "@tiptap/extension-text-style": "3.31.3",
    "@tiptap/extension-typography": "3.31.3",
    "@tiptap/extensions": "3.31.3",
    "@tiptap/pm": "3.31.3",
    "@tiptap/react": "3.31.3",
    "@tiptap/starter-kit": "3.31.3",
    "@uidotdev/usehooks": "2.4.1",
    "@visx/axis": "3.12.0",
    "@visx/curve": "3.12.0",
    "@visx/event": "3.12.0",
    "@visx/grid": "3.12.0",
    "@visx/group": "3.12.0",
    "@visx/responsive": "3.12.0",
    "@visx/scale": "3.12.0",
    "@visx/shape": "3.12.0",
    "@visx/text": "3.12.0",
    "axios": "1.16.0",
    "camelcase": "9.0.0",
    "d3-scale": "4.0.2",
    "decamelize": "6.0.1",
    "i18next": "26.0.9",
    "i18next-browser-languagedetector": "8.2.1",
    "jwt-decode": "4.0.0",
    "keycloak-js": "26.2.4",
    "luxon": "3.7.2",
    "posthog-js": "1.297.4",
    "react-color": "2.19.3",
    "react-error-boundary": "6.1.1",
    "react-hook-form": "7.75.0",
    "react-i18next": "17.0.6",
    "react-toastify": "11.1.0",
    "react-virtuoso": "^4.18.7",
    "zod": "4.4.3",
    "zustand": "5.0.13"
  },
  "devDependencies": {
    "@chromatic-com/storybook": "^5.1.2",
    "@storybook/addon-a11y": "10.3.6",
    "@storybook/addon-docs": "10.3.6",
    "@storybook/addon-themes": "10.3.6",
    "@storybook/addon-vitest": "10.3.6",
    "@storybook/builder-vite": "10.3.6",
    "@storybook/react-vite": "10.3.6",
    "@tanstack/router-plugin": "1.167.34",
    "@types/d3-scale": "4.0.9",
    "@types/luxon": "3.7.1",
    "@types/react": "19.2.14",
    "@types/react-color": "3.0.13",
    "@types/react-dom": "19.2.3",
    "@typescript/native-preview": "beta",
    "@vitejs/plugin-react": "6.0.1",
    "@vitest/browser": "4.1.5",
    "@vitest/browser-playwright": "4.1.5",
    "@vitest/coverage-istanbul": "4.1.5",
    "eslint-plugin-i18next": "6.1.4",
    "happy-dom": "20.9.0",
    "knip": "6.11.0",
    "oxfmt": "0.59.0",
    "oxlint": "1.74.0",
    "playwright": "1.59.1",
    "react": "19.2.5",
    "react-dom": "19.2.5",
    "storybook": "10.3.6",
    "storybook-addon-tag-badges": "3.1.0",
    "typescript": "7.0.2",
    "vite": "8.0.10",
    "vite-bundle-visualizer": "1.2.1",
    "vite-plugin-svgr": "5.2.0",
    "vitest": "4.1.5"
  },
  "browserslist": {
    "production": [
      ">0.2%",
      "not dead",
      "not op_mini all"
    ],
    "development": [
      "last 1 chrome version",
      "last 1 firefox version",
      "last 1 safari version"
    ],
    "staging": [
      "last 1 chrome version",
      "last 1 firefox version",
      "last 1 safari version"
    ]
  },
  "packageManager": "pnpm@11.16.0",
  "knip": {
    "ignoreExportsUsedInFile": true,
    "ignore": [
      "src/storybook/**",
      "src/public/**"
    ]
  }
}
